<template>
  <!-- 新增界面 -->
<!--  <el-dialog title="新增车辆" :visible.sync="addFormVisible" :modal-append-to-body='false'>-->
  <EditFormDialog
    :formData="addForm"
    :formType="'add'"
    :loading="addFormVisible"
    @closeDialog="closeDialog"
    @submitForm="addSubmit"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form :model="addForm" ref="addForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-form-item :label="$t('suo-shu-yun-ying-shang')" :label-width="formLabelWidth" prop="operatorId">
<!--        <el-select placeholder="所属运营商" v-model="addForm.operatorId">
          <el-option v-for="item in operatorForSelect" :key="item.id"
                     v-bind:label="item.name" v-bind:value="item.id"></el-option>
        </el-select>-->
        <el-cascader  size="mini" clearable ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')"  filterable
                      :options="operatorTree"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="addForm.operatorId">
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('che-pai-hao-ma')" :label-width="formLabelWidth" prop="license">
        <el-input v-model="addForm.license" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('xing-hao')" :label-width="formLabelWidth" prop="carTypeId">
          <el-select :placeholder="$t('xing-hao-0')" v-model="addForm.carTypeId">
            <el-option v-for="item in listForSelect" :key="item.id"
                       v-bind:label="item.model" v-bind:value="item.id"></el-option>
          </el-select>
      </el-form-item>
<!--      <el-form-item label="车型" :label-width="formLabelWidth" prop="model">-->
<!--        <el-select placeholder="车型" v-model="addForm.model">-->
<!--          <el-option v-for="item in listForSelect" :key="item.id"-->
<!--                     v-bind:label="item.model" v-bind:value="item.model"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item :label="$t('che-liang-vin')" :label-width="formLabelWidth" prop="vin">
        <el-input v-model="addForm.vin" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ETC')" :label-width="formLabelWidth" prop="etc">
        <el-input v-model="addForm.etc" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('che-zhu-shou-ji-hao')" :label-width="formLabelWidth" prop="phone">
        <el-input v-model="addForm.phone" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="addFormVisible = false">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="addSubmit" :loading="addSubmitLoading">{{ $t('que-ding') }}</el-button>
    </div>
  </EditFormDialog>


</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import commonApi from "../../../api/commonApi";
    import carApi from "../../../api/carApi";
    import EditFormDialog from '@/components/EditFormDialog'
    import {validateInput, validatePhone,validateCarNum} from '../../../../../common/validator'
    import commonApi2 from '@/common/api/commonApi.js'
    import {group} from "../../../../systemManagement/util/user";

    export default {
        name: "add",
        data() {
            return {
                editFormRules: {
                    operatorId: [{required: true, message: this.$t('monitoringCenter.opsTreePlaceholder'), trigger: 'blur'}],

                    license: [
                        {required: true, message: this.$t('qing-shu-ru-che-pai-hao'), trigger: 'blur'},
                        {validator: function (rule, value, callback) {
                                validateCarNum(rule, value, callback)
                            }, trigger: 'blur'}],
                    carTypeId: [{required: true, message: this.$t('qing-xuan-ze-che-xing'), trigger: 'blur'}],
                    vin: [
                        {required: true, message: this.$t('qing-shu-ru-vin-ma'), trigger: 'blur'},{validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,17,17,true,true,true,false,false,true,false)
                            },required: true,trigger: 'blur'}],
                },
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                operatorTree: [],
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                addBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                addBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'carList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'carList'
            }
        },
        methods: {
            closeDialog(formType) {
              this.restForm()
              this.$emit("closeDialog", formType)
            },
            restForm() {
                this.addForm = {}
            },
            addSubmit(addForm) {
                this.$refs.addForm.validate((valid) => {
                    {
                      if (!valid) {
                        return;
                      } else
                        carApi.checkDuplicateCar(this.addForm.license).then((res) => {
                          if (res) {
                            this.$message.error(this.$t('che-liang-yi-tian-jia'))
                          } else {
                            this.addSubmitLoading = true
                            if(group(this.$store.getters.userType)){
                              this.addForm.groupId = this.$store.getters.operatorId
                              this.addForm.carBelongType = 'group'
                            }
                            let param = JSON.stringify(this.addForm)
                            carApi.saveOrUpdateCar(param).then((res) => {
                              this.addSubmitLoading = false
                              if (res.code === 0) {
                                this.$message({
                                  message: res.message,
                                  type: 'success'
                                })
                                this.addFormVisible = false
                                this.restForm()
                                this.$emit('afterAdd')
                                // this.submitCarSearchForm()
                              } else {
                                this.$message.error(res.message)
                              }
                            })
                          }
                        })
                    }
                  })
            },

            // 加载下拉框
            loadSelectItem() {
                let param = Object.assign({}, this.pageparm)
                // brand下拉框
                commonApi.listForSelectQuery(param).then((res) => {
                    if (res.code === 0) {
                        this.listForSelectQuery = res.data.records
                    }
                })
                // 运营商下拉框
                commonApi.operatorSelectionList().then((res) => {
                    if (res.code === 0) {
                        this.operatorForSelect = res.data
                    }

                })
                commonApi2.getOperatorsTree().then((res) => {
                    if (res.code === 0) {
                      this.operatorTree = res.data
                    }

                })
                // model下拉框
                commonApi.listForSelect(param).then((res) => {

                    if (res.code === 0) {
                        this.listForSelect = res.data.records
                    }
                    // console.log(res)
                })
            },

            handleSelectionChange(val) {
                this.multipleSelection = val
            },

            handleChangeOperator(value) {
              let operatorId = value &&value.length >0 ? value[value.length-1] : ''
              this.addForm.operatorId= operatorId
              this.$refs.cascader.dropDownVisible = false
            },
            changeCarPage() {
                this.submitCarSearchForm()
            },

            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },
            handleSelect(item) {
                // console.log(item)
            }
        },
        components: {
            Pagination,
            EditFormDialog
        },
        created: function () {
            this.loadSelectItem()
        },
        mounted: function () {


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/carList/add.vue